<div class="contact-data-sticky-bar">
    <mat-expansion-panel [expanded]="isExpanded">
        <mat-expansion-panel-header>
            <mat-panel-title class="contact-data-sticky-bar__title">Si eres {{titleSticky}} en Ciencuadras, recibe un regalo acá</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="contact-data-sticky-bar__panel-content">
            <form class="contact-data-sticky-bar__form" [formGroup]="form" (ngSubmit)="submit()">
                <ng-container *ngFor="let field of ['name', 'email', 'phone']">
                    <mat-form-field appearance="outline">
                        <input matInput [placeholder]="getPlaceholder(field)" [formControlName]="field">
                        <mat-error *ngIf="getError(field, 'required')">
                            <mat-icon role="img" class="mat-icon material-icons mat-icon-no-color" aria-hidden="true">error</mat-icon>
                            {{ getErrorMessage(field, 'required') }}
                        </mat-error>
                        <mat-error *ngIf="getError(field, 'pattern')">
                            <mat-icon role="img" class="mat-icon material-icons mat-icon-no-color" aria-hidden="true">error</mat-icon>
                            {{ getErrorMessage(field, 'pattern') }}
                        </mat-error>
                    </mat-form-field>
                </ng-container>
                <button [disabled]="isSending" class="contact-data-sticky-bar__button button primary "
                    type="submit">Enviar</button>
            </form>
            <p class="contact-data-sticky-bar__first-paragraph">Tus datos serán utilizado para enviarte información y ofertas de nuestros servicios.</p>
            <p>Al hacer clic en Enviar declaras haber leído nuestras políticas de tratamiento de datos personales.
            </p>
        </div>
    </mat-expansion-panel>
</div>